import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { currentLocale } from '../../i18n'
import { opcionesPais } from './paises'
import ComercialBuscador from './ComercialBuscador'

// A country by typing its name or ISO code (D1, E5-4): Chile first, the rest
// by name in the user's language. value: 'CL' or '' / null.
export default function ComercialSelectorPais({ value, onChange, placeholder, textoVacio, ...resto }) {
  const { t } = useTranslation('comercial')      // re-renders on a language change
  const locale = currentLocale()
  const opciones = useMemo(() => opcionesPais(locale).map(p => ({ value: p.codigo, label: p.nombre, detalle: p.codigo })),
    [locale])
  return (
    <ComercialBuscador opciones={opciones} value={value || null} onChange={v => onChange(v || '')}
      placeholder={placeholder ?? t('form.paisPlaceholder')} textoVacio={textoVacio ?? t('form.sinPais')}
      sinCoincidencias={t('form.sinCoincidencias')} {...resto} />
  )
}
